import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { style } from '@vanilla-extract/css';

export const adminTab = style({
  selectors: {
    '&:is(&)': {
      color: themeVars.container.foreground.warning,
    },
  },
});
